import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, DatePicker, Checkbox} from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import FromInput from '../../../../components/user/from/Input'
import InputDateStartEnd from '../../../../components/user/from/InputDateStartEnd'
import { checkType } from '../../../../utils/checkType'
import { changeFormatdate } from '../../../../utils/formatdate'
import { numberWithCommas } from '../../../../utils/number'
import { approveStatus, confirmCheckDisbled } from '../../../../utils/leave'
import { checkMoreThanLess } from '../../../../utils/formatdate'
import moment from 'moment'
import { alertMessage } from '../../../../utils/message'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class ConfirmCreate extends Component {
	state = {
		selectStatus:"W",
		loading:false,
		dataTalbe: [],
      columns: [
         {
            // title: 'เลขที่เอกสาร',
            title: 'รหัสพนักงาน',
            dataIndex: 'empCode',
            width:200,
            // align:'center',
            render: (item, record, index) => <span>{ item }</span>
            // render: (item, record, index) => <span>{ item }</span>
         },
         {
               title: 'ชื่อ - นามสกุล',
               dataIndex: 'employeeName',
               width:200,
               align:'center',
               render: (item, record, index) => <span>{ item }</span>
         },
         {
            title: 'ฝ่าย',
            dataIndex: 'division',
            width:200,
            align:'center',
            render: (item, record, index) => <span>{ item }</span>
         },
         {
            title: 'หน่วยงาน',
            dataIndex: 'department',
            width:200,
            align:'center',
            render: (item, record, index) => <span>{ item ? item : '-' }</span>
         },
         {
            title: 'ประเภทการลา',
            dataIndex: 'leaveType',
            align:'center',
            width:200,
            align:'center',
            render: (item, record, index) => <span>{ item ? item : '-' }</span>
         },
         {
            title: 'จำนวนวันลา',
            dataIndex: 'totalDayOff',
            width:200,
            align:'center',
            // sorter: (a, b) => a.orgCode - b.orgCode,
            render: (item, record, index) => <span>{ item } </span>
         },
      //    {
      //       title: 'ฝ่าย / หน่วยงาน',
      //       dataIndex: 'department',
      //       width:300,
      //       align:'center',
      //       render: (item, record, index) => <div  style={{ textAlign:"left" }}>
      //                                           { this.onChangeNameDivitions(record.division, record.department) }
      //                                        </div>
      //    },
      //    {
      //          title: 'ประเภทการลา',
      //          dataIndex: 'leaveTypeLabel',
      //          width:200,
      //          align:'center',
      //          render: (item, record, index) => <span>{ item }</span>
      //    },
      //    {
      //       title: 'จำนวนวันลา',
      //       dataIndex: 'leaveDay',
      //       width:200,
      //       align:"center",
      //       render: (item, record, index) => <span>{ item }</span>
      //    },
      // {
      //       title: 'สถานะ',
      //       dataIndex: 'status',
      // 	   width:"200px",
      //       render: (item, record, index) => <span>{approveStatus(item)}</span>
      //    },
      //    {
      //       title: 'จัดการ',
      //       dataIndex: '7',
      //       width:120,
      //       // fixed: 'right',
      //       align:"center",
      //       render: (item, record, index) => {
      //          return <>
      //       <Link
      //          to={{
      //             pathname: '/Leave/Confirm/'+record.docId+'/'+record.status
      //          }}
      //       >
      //                <Icon type="form" className="mr-2"/>
      //       </Link>
      //       {/* <Popconfirm placement="topRight" title={"คุณต้องการที่จะลบ"} onConfirm={ () => this.delectField('1')} okText="ตกลง" cancelText="ยกเลิก">
      //          <Icon type="delete"/>
      //       </Popconfirm> */}
      //          </>
      //       }
      //    },
      ],
		pageData: {
         offset: 0,
         limit: 10
      },
      pagination: {
         total: 10,
      },
      dataSelectTable:[],
		disabledDateStart:moment(new Date).add(-1, 'year'),
		endStartValues:moment(new Date).add(1, 'year'),
		endStartValues:moment(),
		dropdownLeaveType:[],
		checkBoxTitle: false
	}

	delectField = (id) =>{
		// alert('test')
	}
	
   onChangeNameDivitions = (division, department) =>{
      if(division && department){
         return <p className="mb-0">{ division+' / '+department }</p>;
      }else if(division){
         return <p className="mb-0">{ division }</p>;
      }else if(department){
         return <p className="mb-0">{ department }</p>;
      }else{
         return <p className="mb-0" style={{ textAlign:"center" }}> - </p>
      }
   }
	dropdownLeaveType = async ()=>{
        const { client, location, match } = this.props
        const { empCode } = this.state
        const { data, errors } = await client.query({
            query: Queries.dropdownLeaveType,
            variables:{
                // empCode
                isReqByEmp:false
            }
        })

        console.log('data.dropdownLeaveType',data.dropdownLeaveType)

        if(data.dropdownLeaveType){
            await this.setState({
                dropdownLeaveType: data.dropdownLeaveType,
            })
        }
    }

	clearInput = async () =>{
		this.props.form.resetFields();
	}

	onChangeValueDateStart = async (e) =>{

		const { endStartValues } = this.state

		await this.setState({
			 disabledDateStart: moment(e),
		})
		console.log('endStartValues',endStartValues)

        let checkDatemore = checkMoreThanLess(e, endStartValues)

        if(checkDatemore){
            await this.props.form.setFieldsValue({
            	leaveEndDate: checkDatemore,
            })

			await this.setState({
				endStartValues: checkDatemore
			})
        }
	 }

	 onChangeValueDateEnd = async (e) =>{
		await this.setState({
			endDate: moment(e),
		})
	}
 
	 disabledDate = (current) =>{
		 const { disabledDateStart } = this.state
		 return current && current < disabledDateStart;
	 }

	onChangeSlectAll = async (value) =>{
		const { dataTalbe } = this.state
		let arrayNewsDataTable = []
		const rowsDataSelectTable = []
		const rows = null
		if(value){
			await dataTalbe.map((values, keys)=>{

            if(values.status == 'W'){
               values.statusCheckBox = value
               arrayNewsDataTable[keys] = values
               rowsDataSelectTable.push({
                        docId:values.docId, 
                        durationType: values.durationType,
                        leaveStartDate: values.leaveStartDate,
                        leaveEndDate: values.leaveEndDate,
                     })
            }
				
			})
		}else{
			await dataTalbe.map((values, keys)=>{
				values.statusCheckBox = value
				arrayNewsDataTable[keys] = values
			})
		}


		await this.setState({
			dataTalbe: arrayNewsDataTable,
			dataSelectTable:rowsDataSelectTable,
			checkBoxTitle:value
		})
		
	}
     
    onChangeSlectTable = async(values, docId, arrayId, record) =>{
        let dataSourceitems = [...this.state.dataSelectTable];
        let keysdataSelectTable = null

        let dataSourceitemsTable = [...this.state.dataTalbe];
        let item = {...dataSourceitemsTable[arrayId]};
        item.statusCheckBox = values

        dataSourceitemsTable[arrayId] = item;

        await this.setState({
            dataTalbe:dataSourceitemsTable
        },() => {
            // this.cllBackSetValueContactNumber()
        })

        dataSourceitems.map(async(filtereditem, keys) =>{
            if(filtereditem.docId == docId){
                keysdataSelectTable = keys
            }
        })

        if(values){
            const rows = {
                docId: docId,
				durationType: record.durationType,
				leaveStartDate: record.leaveStartDate,
				leaveEndDate: record.leaveEndDate,
				// name: record.name,
				// age: record.age,
				// address: record.address,
                // status:true,
                // money: record.money
            }
            await this.setState(prevState => ({
                dataSelectTable: [...prevState.dataSelectTable, rows],
            }), () => {
                // this.cllBackSetValueOrganizatuions()
            })
        }else{
            dataSourceitems.filter(item => item.docId == docId).map((filtereditem) => {
                var arrayDataSource = [...this.state.dataSelectTable];
                    arrayDataSource.splice(keysdataSelectTable, 1);
                    
                    this.setState({
                        dataSelectTable:arrayDataSource,
                    },() => {
                    // this.cllBackSetValueContactNumber()
                    })
            })
        }
    }

	fetchTotalDayOff =  async() =>{
		const { client,location , match } = this.props
		const { offset ,limit, disabledDateStart, endDate } = this.state
		
		let dataTalbeArray = []

		await this.setState({
			preLoadSubmit:true,
			loading:true
		})

		const { data, errors } = await client.query({
			query: Queries.fetchTotalDayOff,
			variables: {
				isOptional: true
			}
		})

		console.log('datasssss',data.fetchTotalDayOff)

		if(data.fetchTotalDayOff){
			await this.setState({
				dataTalbe: data.fetchTotalDayOff,
				preLoadSubmit:false,
				loading:false
			})
		}else{
			await this.setState({
				preLoadSubmit:false,
				loading:false
			})
		}
	}

	handleSubmit = async (e) => {
      const { form, afterSubmit, client } = this.props
      const { telNo, otpToken, refCode } = this.state
		await e.preventDefault()
		let dataTalbeArray = []
		form.validateFields(async (err, values) => {
			console.log('values',values)
			await this.setState({
				formValue: e,
				loading:true
			})

			// await this.fetchLeaveDocumentList(values)
			if (!err) {
            try {
               let valuesSend = {
                  searchKeyword: values.searchKeyword,
                  isOptional: true,
               }
               if(values.leaveType !== 'A'){
                  valuesSend.leaveType = values.leaveType;
               }
               
               console.log('valuesSend', valuesSend)

					const { data, errors } = await client.query({
						query: Queries.fetchTotalDayOff,
						variables: {
							...valuesSend,
						}
					})

               console.log('data.fetchTotalDayOff', data.fetchTotalDayOff)

					await this.setState({
						selectStatus: values.approveStatus
					})
		
					if(data.fetchTotalDayOff){
						data.fetchTotalDayOff.map((valuesList, keys) =>{
							valuesList.statusCheckBox = false
							valuesList.durationType = valuesList.durationType
							dataTalbeArray.push(valuesList);
						})

						await this.setState({
							dataTalbe: dataTalbeArray,
							preLoadSubmit:false,
							loading:false
						})
					}else{
						await this.setState({
							dataTalbe:[],
							loading:false,
							preLoadSubmit:false,
						})
					}
                }catch (error) {
					console.log('error',error)
                }
			}
		})
	}

	fetchCountListAllApproving = async () =>{
		const { client } = this.props
		const { data } = await client.query({
			query: Queries.fetchCountListAllApproving,
		})

		sessionStorage.setItem('totalLeaveCount', data.fetchCountListAllApproving.leaveCount);
		sessionStorage.setItem('totalWdHospitalCount', data.fetchCountListAllApproving.wdHospitalCount);

		if(document.getElementById('value-LeaveCount-title').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
			document.getElementById('value-LeaveCount-title').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.leaveCount : 0);
		}

		// if(document.getElementById('value-LeaveCount-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
		// 	document.getElementById('value-LeaveCount-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.leaveCount : 0);
		// }

		if(document.getElementById('value-wdHospital-title').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
			document.getElementById('value-wdHospital-title').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.wdHospitalCount : 0);
		}

		// if(document.getElementById('value-wdHospital-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0]){
		// 	document.getElementById('value-wdHospital-subtitle').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountListAllApproving ? data.fetchCountListAllApproving.wdHospitalCount : 0);
		// }
	}

	setToApprover = async (values) =>{
      const { form, afterSubmit, client } = this.props
		const { 
            dataSelectTable, 
            formValue,
            ModalConfirmFormMessage,
            ModalConfirmFormStatus
         } = this.state

		let constSelect = dataSelectTable.length

		
		try {
			dataSelectTable.map(async (valuesSelect , keys) =>{
				const { data, errors } = await client.mutate({
					mutation: Mutations.updateLeaveDocument,
					variables: {
						docId: valuesSelect.docId,
						durationType: valuesSelect.durationType,
						approveStatus: ModalConfirmFormStatus,
						leaveStartDate: valuesSelect.leaveStartDate,
						leaveEndDate: valuesSelect.leaveEndDate,
                  noteApprove: values.ModalNoteApprove,
                  autoApprove: false
					}
				})

				if(constSelect-1 == keys){
					message.success(ModalConfirmFormMessage)
               await this.hideModalConfirm()
					await this.setState({
						dataSelectTable:[]
					})

					await this.fetchCountListAllApproving()
					
					if(formValue){
						await this.handleSubmit(formValue)
					}else{
						await this.fetchTotalDayOff()
					}
				}else{
               await this.hideModalConfirm()
            }
			})
		}catch (error) {
			console.log('error',error)
		}
	}

   showModalFormConfirm = async (
      status, 
      messageForm, 
      title , 
      textBtnOK, 
      ModalFormTextArea, 
      ModalFormTextAreaRequie
   ) =>{
      const { form, client } = this.props
      const { dataSelectTable } = this.state
         
         this.setState({
            preLoadOnsubmit: true
         })

      if(dataSelectTable.length !== 0){
         await this.setState({
            ModalConfirmFormTitle:title,
            ModalConfirmFormSubTitle:'',
            ModalConfirmFormShowModal:true,
            ModalConfirmFormBtnOk:textBtnOK,
            ModalConfirmFormBtnCancel:'ยกเลิก',
            ModalConfirmFormValue:{},
            ModalConfirmFormStatus:status,
            ModalConfirmFormMessage: messageForm,
            ModalFormTextArea,
            ModalFormTextAreaRequie
         })
      }else{
         let content = ''
         // message.warning('กรุณาเลือกเอกสาร อย่างน้อย 1 รายการ');
         if(status == 'REJECT'){
            content = 'กรุณาเลือกเอกสารที่ไม่อนุมัติรายการขอเบิก'
         }else if(status == 'APPROVE'){
            content = 'กรุณาเลือกเอกสารที่จะทำการอนุมัติรายการขอเบิก'
         }else if(status == 'MOREINFO'){
            content = 'กรุณาเลือกเอกสารที่จะทำการขอเอกสารเพิ่มเติมรายการขอเบิก'
         }

         alertMessage("warning",content)

         // message.warning({
         // 	content: content,
         // 	key:'1',
         // 	duration: 3,
         // })
      }
   }

   hideModalConfirm = async () =>{
      await this.setState({
          ModalConfirmFormTitle:null,
          ModalConfirmFormSubTitle:null,
          ModalConfirmFormShowModal:false,
          ModalConfirmFormBtnOk:null,
          ModalConfirmFormBtnCancel:null,
          ModalConfirmFormValue:null,
          ModalConfirmFormStatus:null,
         ModalConfirmFormMessage:null
      })
  }

	submitReject = async () =>{
		const { dataSelectTable } = this.state

		if(dataSelectTable.length !== 0){
			// await this.setToApprover('N', 'ไม่อนุมัติรายการขอลาที่เลือกเรียบร้อย')
         await this.showModalFormConfirm(
                  'N', 
                  'ไม่อนุมัติรายการขอลาที่เลือกเรียบร้อย', 
                  'ท่านไม่อนุมัติรายการขอลา ด้วยสาเหตุใด?', 
                  'ยืนยัน',
                  true,
                  true,
               )
		}else{
			message.warning({
				content: 'กรุณาเลือกเอกสารที่จะไม่อนุมัติการขอลา',
				key:'1',
				duration: 2,
			})
		}
	}

	submitApprover = async () =>{
		const { dataSelectTable } = this.state

		if(dataSelectTable.length !== 0){
			// await this.setToApprover('Y', 'ทำการอนุมัติรายการขอลาที่เลือกเรียบร้อย')
         await this.showModalFormConfirm(
            'Y', 
            'ทำการอนุมัติรายการขอลาที่เลือกเรียบร้อย', 
            'ท่านต้องการอนุมัติรายการขอลา', 
            'ยืนยัน',
            false,
            false,
         )
		}else{
			message.warning({
				content: 'กรุณาเลือกเอกสารที่จะอนุมัติการขอลา',
				key:'1',
				duration: 2,
			})
		}
	}

	onChangeStatus = async (e) =>{
		await this.setState({
			selectStatus: e,
			checkBoxTitle:false
		})
		await this.onChangeSlectAll(false)
	}

	async componentDidMount(){
		await this.fetchTotalDayOff()
		await this.dropdownLeaveType()
		// const divsss = document.getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = parseInt(data.fetchCountAllNotification);
		// const divsss = document.getElementById('value-LeaveCount-title').innerHTML = parseInt('12313');
    }

	render() {
		const { match } = this.props
		const { 
			dataTalbe, 
			columns, 
			loading, 
			pagination, 
			valuesEndDate, 
			disabledDateStart, 
			endStartValues,
			dataSelectTable,
			preLoadSubmit,
			dropdownLeaveType,
			selectStatus,
         ModalConfirmFormTitle,
         ModalConfirmFormSubTitle,
         ModalConfirmFormShowModal,
         ModalConfirmFormBtnOk,
         ModalConfirmFormBtnCancel,
         ModalConfirmFormValue,
			ModalFormTextArea,
        	ModalFormTextAreaRequie,
		} = this.state
		const { getFieldDecorator } = this.props.form;
        // console.log('selectStatus', selectStatus)
        console.log('dataTalbe', dataTalbe) 
		return (
			<Container match={match}>
				<div className="breadcrumb-custom pb-3 mb-5">
               {/* <Breadcrumb.Item> */}
                  <span style={{ fontSize:"18px" }}>การลา / สรุปข้อมูลการลา</span>
               {/* </Breadcrumb.Item> */}
            </div>
            <ModalConfirmForm 
               title={ModalConfirmFormTitle} 
               subtitle={ModalConfirmFormSubTitle}
               showModal={ModalConfirmFormShowModal} 
               btnOk={ModalConfirmFormBtnOk} 
               btnCancel={ModalConfirmFormBtnCancel}  
               submitToSend={ this.setToApprover }
               hideModal={ this.hideModalConfirm }
               valueConfirm = { ModalConfirmFormValue }
               ModalFormTextArea = {ModalFormTextArea}
               ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
            />
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Form onSubmit={this.handleSubmit}>
							<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mb-0" >
								<Col xs={24} md={24} className="pt-2 mb-4">
									<strong className="color-red">
										ค้นหา
									</strong>
								</Col>

                        <Col xs={24} md={12}>
                           <Form.Item label={"ค้นหา"}>
                                 { getFieldDecorator("searchKeyword", {
                                    initialValue: '',
                                    rules:  [{ 
                                       required:false, 
                                    }],
                                 })(
                                    <Input 
                                       className='block-news' 
                                    />
                                 )}
                           </Form.Item>
                        </Col>

								<Col xs={ 24 } md={8}>
									<Form.Item label={"ประเภทการลา"}>
										{ this.props.form.getFieldDecorator("leaveType", {
											initialValue: "A",
											rules:  [{ 
												message: 'กรุณากรอกเลือกประเภทการลา',
											}],
										})(
											<Select 
												style={{ width: "100%" }}
												showSearch
												placeholder=""
												optionFilterProp="children"
											>
												<Option value={"A"}>ทั้งหมด</Option>
												{
													dropdownLeaveType.length !== 0 ? 
														dropdownLeaveType.map((valuseLabel, keysLabel) =>{
															return <Option value={valuseLabel.value}>{ valuseLabel.label }</Option>
														})
													: ''
												}
											</Select>
										)}
									</Form.Item>
								</Col>

								{/* <Col xs={ 24 } md={8}>
									<Form.Item label="วันที่เริ่มลา" className="mb-0">
										{ getFieldDecorator('leaveStartDate', {
											initialValue: disabledDateStart,
											rules:  [{ 
												required:false,
												message: 'กรุณากรอกหรือเลือก วันที่ลา',
											}],
										})(
											<DatePicker 
												className="w-100"  
												placeholder="เลือกวันที่" 
												onChange={(e) => this.onChangeValueDateStart(e)}
												allowClear={false}
											/>
										)}
									</Form.Item>
								</Col>
								
								<Col xs={ 24 } md={8}>
									<Form.Item label="วันที่สิ้นสุดการลา" className="mb-0">
										{ getFieldDecorator('leaveEndDate', {
											initialValue: endStartValues,
											rules:  [{ 
												required:false,
												message: 'กรุณากรอกหรือเลือก วันที่สิ้นสุดการลา',
											}],
										})(
											<DatePicker 
												disabledDate={this.disabledDate} 
												disabled={ disabledDateStart ? false : true }
												className="w-100" 
												// defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
												placeholder="เลือกวันที่"
												onChange={(e) => this.onChangeValueDateEnd(e)}
												allowClear={false}
											/>
										)}
									</Form.Item>
								</Col> */}

								<Col xs={24} md={24} align={"right"}>
									{/* <Button type="primary" className="mx-2 btn-white-red" htmlType="submit" onClick={this.clearInput}>
										ล้างค่า
									</Button> */}
									<Button 
										type="primary" 
										id="btn-onsearch" 
										className="ml-2 color-white" 
										htmlType="submit" 
										disabled={preLoadSubmit}
									>
										ค้นหา
									</Button>
									{
										preLoadSubmit &&
										<Spin size="small" />
									}
								</Col>
							</Row>
						</Form>
					</div>
					<div className="px-5 py-1 card-bg-green">
						<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
							<Col xs={24} md={12} className="pt-2 mb-3">
								<strong className="color-red">
                           สรุปข้อมูลการลา
								</strong>
							</Col>
							<Col xs={ 24 } md={24} className="mb-4">
								<Table
									locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }}
									dataSource={dataTalbe} 
									columns={columns} 
									loading={loading}
									// pagination={{ pageSize: dataTalbe.length }}
									scroll={{ x: '1800',y: 600 }}
									pagination={false}
									// scroll={{ x: 'max-content' }}
								/>
							</Col>

						</Row>
					</div>
				</div>
			</Container>
		)
	}
}

ConfirmCreate.defaultProps = {
	autoFocus: false
}

ConfirmCreate.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedConfirmCreate = Form.create()(ConfirmCreate)

export default withApollo(WrappedConfirmCreate)